import React from "react";
import { FormattedMessage } from "react-intl";
import { Icon, Text, HStack } from "@chakra-ui/react";

import { IoIosAddCircleOutline } from "react-icons/io";

const AddPaymentMethod = ({ onOpen, dataTestId, buttonText }) => {
  return (
    <>
      <HStack
        data-testid={dataTestId}
        spacing="1"
        color="integrator.400"
        fontWeight="600"
        cursor="pointer"
        onClick={onOpen}
      >
        <Icon as={IoIosAddCircleOutline} w="5" h="5" />
        <Text>
          {buttonText || <FormattedMessage defaultMessage="Add payment method" description="button label" />}
        </Text>
      </HStack>
    </>
  );
};

export default AddPaymentMethod;
